<div class="col p-0">
  @if (timelineData) {
    <div class="row" [style.max-height]="'80px'" [style.min-height]="'67px'">
      <div class="col-lg-3 col-md-3 col-sm-12 border-top border-right" style="align-content: center">
        <div
          ><span class="f-12 _800">{{ 'Axe' | translate }}</span></div
        >
        <div
          ><span class="f-18 _450">{{ workspaceName }}</span></div
        >
        @if (!workspaceName) {
          <div
            ><span>{{ 'NA' | translate }}</span></div
          >
        }
      </div>

      <div class="col-lg-3 col-md-3 col-sm-12 border-top border-right" style="align-content: center">
        <div
          ><span class="f-12 _800">{{ 'Type' | translate }}</span></div
        >
        <div
          ><span class="f-16 _450">{{ summaryDetail['Project Type'] | translate }}</span></div
        >
      </div>

      <div class="col-lg-3 col-md-3 col-sm-12 border-top border-right" style="align-content: center">
        <div
          ><span class="f-12 _800">{{ 'ProductDevManager' | translate }}</span></div
        >
        <div class="d-flex justify-content-start align-items-center">
          <div class="row ms-1 d-flex">
            @for (user of timelineData?.projectLeaders; track $index) {
              <div class="user-avatar" [style.z-index]="$index + 1" [style.left]="`${-1 * ($index * 8)}px`">
                <mtm-user-profile-picture
                  placement="left"
                  container="body"
                  [ngbTooltip]="selectedParticipantTooltip"
                  [username]="user"
                  [height]="24"
                  [width]="24">
                </mtm-user-profile-picture>

                <ng-template #selectedParticipantTooltip>
                  <div class="user-tooltip d-flex flex-column align-items-start p-1">
                    <h6 class="user-name m-0">{{ getUserInfo(user) }}</h6>
                  </div>
                </ng-template>
              </div>
            }
          </div>
        </div>
        @if (timelineData?.projectLeaders == null) {
          <div
            ><span>{{ 'NA' | translate }}</span></div
          >
        }
      </div>

      <div class="col-lg-3 col-md-3 col-sm-12 border-top border-right" style="align-content: center">
        <div
          ><span class="f-12 _800">{{ 'Central MAD' | translate }}</span></div
        >
        <div class="f-16 _500">
          <span>
            {{ timelineData.expectedMad ? (getFormatedDate(timelineData.expectedMad) | ngbDate) : 'NA' }}
          </span>
        </div>
      </div>
    </div>

    <div class="row" [style.max-height]="'80px'" [style.min-height]="'67px'">
      <div class="col border-bottom border-top border-right" style="align-content: center">
        <div
          ><span class="f-12 _800">{{ 'LaunchPotential' | translate }}</span></div
        >
        <div class="d-flex align-items-center justify-content-start">
          <div class="col-3 p-0">
            @if (
              summaryDetail['Launch Potential'] === 1 ||
              summaryDetail['Launch Potential'] === 2 ||
              summaryDetail['Launch Potential'] === 3
            ) {
              <i class="fa fa-star ms-2 rating-start" aria-hidden="true"></i>
            }
            @if (summaryDetail['Launch Potential'] === 2 || summaryDetail['Launch Potential'] === 3) {
              <i class="fa fa-star ms-1 rating-start" aria-hidden="true"></i>
            }
            @if (summaryDetail['Launch Potential'] === 3) {
              <i class="fa fa-star ms-1 rating-start" aria-hidden="false"></i>
            }
          </div>
        </div>
      </div>

      @if (summaryDetail['Project Type'] === 'Hallmarks') {
        <div class="col-lg-3 col-md-3 col-sm-12 border-bottom border-top border-right" style="align-content: center">
          <div>
            <span class="f-12 _800">{{ 'Type of Hallmarks' | translate }}</span>
          </div>
          <div class="f-16 _450">
            <span>{{ summaryDetail['Hallmarks Type'] ? summaryDetail['Hallmarks Type'] : ('NA' | translate) }}</span>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 border-bottom border-top border-right" style="align-content: center">
          <div>
            <span class="f-12 _800">{{ 'Set' | translate }}</span>
          </div>

          @if (summaryDetail['Set'] === 'No') {
            <div>
              <span class="f-16 _450">
                {{ 'No' | translate }}
              </span>
            </div>
          }

          @if (summaryDetail['Set Locally Produced'] === 'Yes') {
            <div>
              <span class="f-16 _450">
                {{ 'Yes, Locally Produced' | translate }}
              </span>
            </div>
          }

          @if (summaryDetail['Set DMI Produced'] === 'Yes') {
            <div>
              <span class="f-16 _450">
                {{ 'Yes, DMI Produced' | translate }}
              </span>
            </div>
          }
        </div>
      }

      @if (summaryDetail['Project Type'] === 'Product Campaign') {
        <div class="col-lg-3 col-md-3 col-sm-12 border-bottom border-top border-right" style="align-content: center">
          <div
            ><span class="f-12 _800">{{ 'Product Launch Type' | translate }}</span></div
          >
          <div
            ><span class="f-16 _450">{{
              summaryDetail['Product Launch Type'] ? summaryDetail['Product Launch Type'] : ('NA' | translate)
            }}</span></div
          >
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 border-bottom border-top border-right" style="align-content: center">
          <div>
            <span class="f-12 _800">{{ 'Type of Product Campaign' | translate }}</span>
          </div>
          <div class="f-16 _450">
            <span>{{ summaryDetail['Campaign Type'] ? summaryDetail['Campaign Type'] : ('NA' | translate) }}</span>
          </div>
        </div>
      }

      <div class="col border-bottom border-top border-right" style="align-content: center">
        <div
          ><span class="f-12 _800">{{ 'POSM' | translate }}</span></div
        >

        @if (summaryDetail['POSM'] === 'Yes') {
          @if (summaryDetail['DMI Produced'] === 'Yes' || summaryDetail['POSM DMI Produced'] === 'Yes') {
            <div class="f-16 _450">
              {{ 'Yes, DMI Produced' | translate }}
            </div>
          } @else {
            <div class="f-16 _450">
              {{ 'Yes, Locally Produced' | translate }}
            </div>
          }
        } @else {
          <div class="f-16 _450">
            {{ 'No' | translate }}
          </div>
        }
      </div>
    </div>
  }
</div>
